import { Component, OnInit, Input, OnChanges, EventEmitter, Output } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'exception-root',
    templateUrl: './exception.component.html',
    styleUrls: ['./exception.component.css']
,  standalone: false
})
export class ExceptionComponent implements OnInit
{
    errorCode: string = '404';
    errorMessage: string = "We couldn't find this page.";
    errorHelpText: string = 'Please Contact 1-800-394-5967';
  
    constructor(private route: ActivatedRoute) {}
  
    ngOnInit(): void {
      // Get error details from route parameters
      this.route.queryParams.subscribe(params => {
        if (params['code']) {
          this.errorCode = params['code'];
        }
        if (params['message']) {
          this.errorMessage = params['message'];
        }
        if (params['helpText']) {
          this.errorHelpText = params['helpText'];
        }
      });
    }
}
